import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import utils from '@utils';
import constants from '@utils/constants';
import { Loader, Image, EmptyCard } from '@components/common';
import isEqual from 'lodash/isEqual';

class ActivitiesTimeline extends Component {
	shouldComponentUpdate = ({ notes, timeZone, isLoading }) => {
		const lastProps = this.props;

		return (
			!isEqual(notes, lastProps.notes)
			|| !isEqual(timeZone, lastProps.timeZone)
			|| !isEqual(isLoading, lastProps.isLoading)
		);
	}

	render() {
		const {
			notes,
			deleteNote,
			timeZone,
			isLoading,
			isStaffAdmin,
			userTypeId,
		} = this.props;

		return (
			<React.Fragment>
				<Choose>
					<When condition={notes.length > 0}>
						<ul className="timeline">
							<For
								index="index"
								each="note"
								of={notes}
							>
								<li key={`note_${index}_${note.Id}`}>
									<div>
										<span className="timeline__item__author">
											{ note.UserName }
											{' '}
											added a note
										</span>
										<span className="timeline__item__date">
											{ utils.parseUTCDateToTimeZone(note.CreateDateUTC, timeZone).fromNow() }
											<If condition={
												utils.IsUserType(userTypeId, [constants.USER_TYPE.SUPER_ADMIN])
												|| (utils.IsUserType(userTypeId,
													[constants.USER_TYPE.AGENCY_ADMIN, constants.USER_TYPE.LAW_ENFORCEMENT])
													&& isStaffAdmin)
											}
											>
												<Button
													bsStyle="link"
													className="padding-0 margin-left-5"
													onClick={deleteNote(note.Id)}
												>
													<i className="rkf rkf-trash color-red-torch" />
												</Button>
											</If>
										</span>
									</div>
									<p className="timeline__item__content">
										{ note.Comment }
									</p>
									<If condition={note.Url}>
										<Image
											src={note.Url}
											className="timeline__item__image"
										/>
									</If>
								</li>
							</For>
						</ul>
					</When>
					<Otherwise>
						<EmptyCard height={160} />
					</Otherwise>
				</Choose>

				<Loader
					size="small"
					active={isLoading}
				/>
			</React.Fragment>
		);
	}
}

ActivitiesTimeline.propTypes = {
	deleteNote   : PropTypes.func,
	isLoading    : PropTypes.bool,
	isStaffAdmin : PropTypes.bool,
	notes        : PropTypes.array,
	timeZone     : PropTypes.string,
	userTypeId   : PropTypes.number,
};

ActivitiesTimeline.defaultProps = {
	isStaffAdmin : false,
	deleteNote   : () => {},
	userTypeId   : undefined,
	isLoading    : false,
	notes        : [],
	timeZone     : '',
};

export default ActivitiesTimeline;
